/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'EMERGENCY_EXITS_ARE_ILLUMINATED_AND_VISIBLE_WHEN_IT_IS_DARK_OR_',
              'EMERGENCY_EXIT_DOORS_OPEN_OUTWARDS_OR_ARE_SECURELY_KEPT_OPEN_DU',
              'DOORS_THAT_ARE_NOT_EXITS_ARE_CLEARLY_MARKED_AS_NOT_AN_EXIT_',
              'EMERGENCY_EXIT_LIGHTING_HAS_A_BACK_UP_BATTERY_PROVIDING_CONTINU',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_have_any_of_the_following_additional_safety_measur: valueSchema,
  },
}
